
import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import { getBaseInfo } from './api';

const baseUrl = '0403yspxpc';

@Component({
  components: {},
})
export default class ViewHolder extends Vue {
  activeTab = '个人奖项';
  baseInfo: any = {};
  tabList = ['个人奖项'];
  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '第11届渝商评选-报名表',
      url: location.href,
      subtitle: `第11届渝商评选-报名表`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '第11届渝商评选-报名表',
        subtitle: `第11届渝商评选-报名表`,
        image: cover,
      });
    }
  }

  async created() {
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }
}
